import React from 'react'

const Brand = () => {
  return <h3>Cisco</h3>
}

export default Brand
